export default "__VITE_ASSET__Dq3egkr3__"